export default __webpack_public_path__ + "static/media/harvardmed.2b8b3f1b.png";